import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes'
import store from './../store'
import WeChatConfig from '../config/wechat'
import { isWeiXin } from './../utils/utils'
import Home from './../models/home'
import { shareConfiguration } from './../utils/wachat_share'
import { CodeValidTime, DeleteCode } from '@/utils/tools'
import Env from '@/config/env'
import { Dialog } from 'vant'
import cookies from 'js-cookie'
import {
  saveUserId,
  saveJoinTraderId,
  saveRegisterSource
} from '@/utils/cookie'
const jweixin = require('jweixin-module')

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

//默认的微信分享
const WeChatShare = async (routerQuery, routerPath, routerTitle) => {
  let IsWeiXin = isWeiXin()
  if (IsWeiXin) {
    let config = await Home.getWachatShare(location.href)
    jweixin.config({
      debug: false,
      appId: config['data']['appId'],
      timestamp: config['data']['timestamp'],
      nonceStr: config['data']['nonceStr'],
      signature: config['data']['signature'],
      jsApiList: [
        // 所有要调用的 API 都要加到这个列表中
        'checkJsApi',
        'openLocation',
        'getLocation',
        'onMenuShareTimeline', //分享到朋友圈
        'onMenuShareAppMessage', //分享到好友
        'onMenuShareQQ',
        'onMenuShareQZone',
        'startRecord',
        'stopRecord'
      ],
      openTagList: ['wx-open-launch-app', 'wx-open-launch-weapp']
    })
    //找不到, 就调用默认的分享
    if (customShareList.indexOf(routerPath) == -1) {
      shareConfiguration({
        jweixin: jweixin,
        wstitle: routerTitle
      })
    }
  }
}

const whiteList = [
  '/',
  '/study',
  '/my',
  '/my/index',
  '/my/setting',
  '/login',
  '/register',
  '/register/app',
  // '/course',
  '/micro',
  '/course/index',
  '/app',
  '/course/micro',
  '/group/propaganda',
  '/gift/exchange',
  '/find',
  '/vip/exchange',
  '/live',
  '/live/live',
  '/column/home',
  '/vip/gift',
  '/vip/giftBag',
  '/agreement/useService',
  '/agreement/privacy',
  '/agreement/publish',
  '/agreement/studyCircle',
  '/agreement/vip',
  '/agreement/tallage',
  '/agreement/sdk',
  '/charity',
  '/publicGood',
  '/explain',
  '/famous',
  '/column/activity/vip',
  '/column/activity/trial360',
  '/column/activity/trialWind',
  '/column/activity/trialVip',
  '/column/activity/roseGardenRule',
  '/column/activity/honlanRule',
  '/ranking',
  '/growUp/invitation',
  '/vip/vipLoveNature', //爱自然开通VIP
  '/relation/identifyPosters', //识别海报
  '/life/index', //生活列表页
  '/life/preview', //生活预览页
  '/life/detail', //生活详情页
  '/camp/campReceive', //领取特训营页
  '/askAnswer', //问答
  '/askAnswer/index',
  '/askAnswer/MyQuiz',
  '/askAnswer/MyAnswer',
  '/receiveCoupon',
  '/groupBuy/index',
  '/groupBuy/puzzlePage',
  '/child/indexedition',
  '/child/detailedition',
  '/groupBuy/index',
  '/groupBuy/puzzlePage',
  '/shortVideo',
  '/freeCourse',
  // vip开通页面
  '/vip',
  '/camp/index',
  '/course',
  '/column/family',
  '/child/index',
  '/serviceAgreement',
  '/annualReport',
  '/summaryList',
  '/playbill',
  '/GeneratePoster',
  '/oldGreeting',
  '/camp/campLive',
  '/2023annualReport',
  '/familyGrowth',
  '/child/indexMpFl',
  '/child/detailMpFl',
  '/studyCircle',
  '/liveStream',
  '/liveStream/accompany'
]

//自定义分享静态路径名单
const customShareList = [
  'courseDetail',
  'microCourse',
  '/gift/detail',
  '/gift/detail',
  '/gift/give',
  '/live/live',
  '/gift/receive',
  '/activity/20200501',
  '/giftCard/give',
  '/training/details/',
  '/activity/20201212',
  '/hotCourses',
  '/column/activity/explodeCourse',
  '/activity/20210130',
  '/activity/20210327',
  '/activity/20211111',
  '/activity/20211112',
  '/article/',
  '/child/index',
  '/child/plan',
  '/vip',
  '2023annualReport',
  '/liveStream',
  '/liveStream/accompany'
]
// 自定义拦截离开页面名单
const leaveList = ['/my/personal']

router.beforeEach((to, from, next) => {
  addCardMaterShare(to.query, to.fullPath) //检测url是否携带卡片id以及分享类型
  recordRecommendation(to.query) //检测url是否携带了用户id及注册的资源字段并存储在页面缓存中
  WeChatShare(to.query, to.path, to.meta.title) //设置默认的微信分享配置
  if (
    whiteList.indexOf(to.path) !== -1 ||
    (to.path.indexOf('activity') != -1 &&
      to.path.indexOf('activity/20210327') == -1) ||
    to.path.indexOf('agreement') != -1 ||
    to.path.indexOf('/gift/receive') != -1 ||
    to.path.indexOf('/column/info') != -1 ||
    to.path.indexOf('/column/activity') != -1 ||
    to.path.indexOf('/shortvideo/') != -1 ||
    to.path.indexOf('/courseDetail/') != -1 ||
    to.path.indexOf('/microCourse/detail/') != -1 ||
    to.path.indexOf('/live/') != -1 ||
    to.path.indexOf('/giftCard/accept') != -1 ||
    to.path.indexOf('/vip/giftCard') != -1 ||
    to.path.indexOf('/camp/campDetail') != -1 ||
    to.path.indexOf('/explain/') != -1 ||
    to.path.indexOf('/rose/') != -1 ||
    to.path.indexOf('/famous/') != -1 ||
    to.path.indexOf('/dailySayShare/') != -1 || //每日一说分享
    to.path.indexOf('/growUp/') != -1 ||
    to.path.indexOf('/ranking/') != -1 ||
    to.path.indexOf('/hotCourses') != -1 ||
    to.path.indexOf('/column/activity/explodeCourse') != -1 ||
    to.path.indexOf('/famous/chapterShare/') != -1 || //名门望族章节列表分享
    to.path.indexOf('/chapterShare/') != -1 || //名门望族章节列表分享
    to.path.indexOf('/explain/chapter/') != -1 || //红兰章节列表分享
    to.path.indexOf('/article/') != -1
  ) {
    //next()
  } else if (window.location.pathname.indexOf('/shareLogin') != -1) {
    // 若传入url内含有 '/shareLogin' 字段则将当前页面替换为正式环境下的验证码登陆页面
    // replace不保存页面会话因此无法返回被替代页面
    location.replace(Env.mobileUrlFormal + '/register?type=1')
  } else {
    //当用户token为空时且不是上述白名单页面，则跳转微信获取用户信息
    if (!store.state.user.token) {
      if (Env.mobileUrlList.indexOf(window.location.hostname) !== -1) {
        //在正式环境情况下：
        if (isWeiXin()) {
          let url
          if (to.fullPath == '/group') {
            //如果重定向有code就去掉code
            url = DeleteCode(to.fullPath)
            url = encodeURIComponent(url)
            CodeValidTime()
            location.replace('/register?type=1&redirectUrl=' + url)
          } else {
            //如果重定向有code就去掉code
            url = DeleteCode(to.fullPath)
            url = encodeURIComponent(url)
            CodeValidTime()
            location.replace('/login?redirectUrl=' + url)
          }
        } else {
          next()
        }
      } else {
        //不在正式环境情况下：
        if (isWeiXin()) {
          const appid = WeChatConfig.appid
          const WeChatUrl = WeChatConfig.url
          const myUrl = window.location.origin
          let url = myUrl
          if (to.fullPath == '/group') {
            url +=
              '/register?type=1&redirectUrl=' + encodeURIComponent(to.fullPath)
          } else {
            url += '/login?redirectUrl=' + encodeURIComponent(to.fullPath)
          }
          //如果重定向有code就去掉code
          url = DeleteCode(url)
          CodeValidTime()
          const href =
            WeChatUrl + '?url=' + encodeURIComponent(url) + '&appid=' + appid
          location.replace(href)
        } else {
          next()
        }
      }
    }
  }
  const matched = to.matched[to.matched.length - 1]
  let title = '家慧库'
  if (matched && matched.meta && matched.meta.title) {
    title = matched.meta.title
  }
  document.title = title
  // next()

  // 添加离开页面拦截判断
  if (
    leaveList.includes(from.path) &&
    cookies.get('personalstate') == 'false'
  ) {
    next(false)
    // 出现弹框提示
    Dialog.confirm({
      title: '温馨提示',
      message:
        '您当前修改的数据还未保存\n 离开页面将会掉失您的数据\n 是否选择返回页面',
      confirmButtonText: '确定',
      confirmButtonColor: '#000000',
      showCancelButton: true,
      className: 'Dialog'
    })
      .then(() => {
        next()
      })
      .catch(() => {})
  } else next()
})

// 记录推荐关系
const recordRecommendation = async query => {
  let userId = query.userId
  let joinTraderId = query.joinTraderId
  let registerSource = query.registerSource
  if (
    userId &&
    userId !== 'undefined' &&
    userId !== 'null' &&
    /^[0-9]*$/.test(userId)
  ) {
    saveUserId(userId) //若url内的userID不为空，则将cookies改成session 仅在当前窗口有效 即在此应用程序中有效
  }
  if (
    joinTraderId &&
    joinTraderId !== 'undefined' &&
    joinTraderId !== 'null' &&
    /^[0-9]*$/.test(joinTraderId)
  ) {
    saveJoinTraderId(joinTraderId) //同 saveUserId()
  }
  if (
    registerSource &&
    registerSource !== 'undefined' &&
    registerSource !== 'null'
  ) {
    saveRegisterSource(registerSource) //存储注册的资源字段进入页面缓存中，可在本窗口调用
  }
}
// 记录url是否带有分享曝光字段
const addCardMaterShare = (query, fullPath) => {
  // 全局监听路由参数是否带有以下分享曝光字段
  if (fullPath.indexOf('cardId') != -1) {
    Home.addCardMaterShareNum({
      cardId: query.cardId,
      shareType: query.shareType
    })
  }
}
export default router
